import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import KeyRecovery from './pages/KeyRecovery'
import About from './pages/About'
import HowItWorks from './pages/HowItWorks'
import Features from './pages/Features'
import Security from './pages/Security'
import Contact from './pages/Contact'
import ErrorBoundary from './components/layout/ErrorBoundary'
import { isValidKey } from './utils/key'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function App() {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Routes>
        {/* Landing page (also handles legacy #<key> URLs) */}
        <Route path="/" element={<Home />} />

        {/* Main dashboard, keyed by user key in the path */}
        <Route path="/u/:userId/*" element={<Dashboard />} />

        {/* Public marketing pages */}
        <Route path="/about" element={<About />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/features" element={<Features />} />
        <Route path="/security" element={<Security />} />
        <Route path="/contact" element={<Contact />} />

        {/* Key recovery via backup email */}
        <Route path="/recover" element={<KeyRecovery />} />

        {/* Anything else: try a legacy hash redirect, else home */}
        <Route path="*" element={<LegacyRedirect />} />
      </Routes>
    </ErrorBoundary>
  )
}

// Handle legacy hash-based URLs (#<key> -> /u/<key>)
function LegacyRedirect() {
  if (typeof window !== 'undefined' && window.location.hash) {
    const key = window.location.hash.slice(1)
    if (isValidKey(key)) {
      return <Navigate to={`/u/${key}`} replace />
    }
  }
  return <Navigate to="/" replace />
}
